// This file is auto-generated by @hey-api/openapi-ts

import type { Client, Options as Options2, TDataShape } from './client';
import { client } from './client.gen';
import type { BulkUpdateFavoriteData, BulkUpdateFavoriteErrors, BulkUpdateFavoriteResponses, BulkUpdateTagsData, BulkUpdateTagsErrors, BulkUpdateTagsResponses, BulkUpdateTrashData, BulkUpdateTrashErrors, BulkUpdateTrashResponses, CreateBookmarkByUrlData, CreateBookmarkByUrlErrors, CreateBookmarkByUrlResponses, CreateBookmarkData, CreateBookmarkErrors, CreateBookmarkResponses, CreateTagData, CreateTagErrors, CreateTagResponses, DeleteItemsData, DeleteItemsErrors, DeleteItemsResponses, DeleteTagData, DeleteTagErrors, DeleteTagResponses, FetchItemsTagsStatsData, FetchItemsTagsStatsErrors, FetchItemsTagsStatsResponses, GetBookmarkData, GetBookmarkErrors, GetBookmarkResponses, GetTagsData, GetTagsErrors, GetTagsResponses, SearchItemsAutocompleteData, SearchItemsAutocompleteErrors, SearchItemsAutocompleteResponses, SearchItemsData, SearchItemsErrors, SearchItemsResponses, SendEmailData, SendEmailErrors, SendEmailResponses, UpdateBookmarkData, UpdateBookmarkErrors, UpdateBookmarkResponses, UpdateTagData, UpdateTagErrors, UpdateTagResponses } from './types.gen';

export type Options<TData extends TDataShape = TDataShape, ThrowOnError extends boolean = boolean> = Options2<TData, ThrowOnError> & {
    /**
     * You can provide a client instance returned by `createClient()` instead of
     * individual options. This might be also useful if you want to implement a
     * custom client.
     */
    client?: Client;
    /**
     * You can pass arbitrary values through the `meta` object. This can be
     * used to access values that aren't defined as part of the SDK function.
     */
    meta?: Record<string, unknown>;
};

/**
 * Returns a bookmark item
 */
export const getBookmark = <ThrowOnError extends boolean = false>(options: Options<GetBookmarkData, ThrowOnError>) => {
    return (options.client ?? client).get<GetBookmarkResponses, GetBookmarkErrors, ThrowOnError>({
        responseType: 'json',
        url: '/v1/bookmarks/{id}',
        ...options
    });
};

/**
 * Updates a bookmark item and returns it
 */
export const updateBookmark = <ThrowOnError extends boolean = false>(options: Options<UpdateBookmarkData, ThrowOnError>) => {
    return (options.client ?? client).patch<UpdateBookmarkResponses, UpdateBookmarkErrors, ThrowOnError>({
        responseType: 'json',
        url: '/v1/bookmarks/{id}',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * Creates a bookmark item by Url and returns it
 */
export const createBookmarkByUrl = <ThrowOnError extends boolean = false>(options: Options<CreateBookmarkByUrlData, ThrowOnError>) => {
    return (options.client ?? client).post<CreateBookmarkByUrlResponses, CreateBookmarkByUrlErrors, ThrowOnError>({
        responseType: 'json',
        url: '/v1/bookmarks/url',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * Creates a bookmark item and returns it
 */
export const createBookmark = <ThrowOnError extends boolean = false>(options: Options<CreateBookmarkData, ThrowOnError>) => {
    return (options.client ?? client).post<CreateBookmarkResponses, CreateBookmarkErrors, ThrowOnError>({
        responseType: 'json',
        url: '/v1/bookmarks',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * Sends an email from template
 */
export const sendEmail = <ThrowOnError extends boolean = false>(options: Options<SendEmailData, ThrowOnError>) => {
    return (options.client ?? client).post<SendEmailResponses, SendEmailErrors, ThrowOnError>({
        responseType: 'json',
        url: '/v1/emails',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * Bulk favorite or unfavorite items
 */
export const bulkUpdateFavorite = <ThrowOnError extends boolean = false>(options: Options<BulkUpdateFavoriteData, ThrowOnError>) => {
    return (options.client ?? client).patch<BulkUpdateFavoriteResponses, BulkUpdateFavoriteErrors, ThrowOnError>({
        responseType: 'json',
        url: '/v1/items/bulk/favorite',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * Bulk add or remove tags from items
 */
export const bulkUpdateTags = <ThrowOnError extends boolean = false>(options: Options<BulkUpdateTagsData, ThrowOnError>) => {
    return (options.client ?? client).patch<BulkUpdateTagsResponses, BulkUpdateTagsErrors, ThrowOnError>({
        responseType: 'json',
        url: '/v1/items/bulk/tags',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * Bulk trash or restore items
 */
export const bulkUpdateTrash = <ThrowOnError extends boolean = false>(options: Options<BulkUpdateTrashData, ThrowOnError>) => {
    return (options.client ?? client).patch<BulkUpdateTrashResponses, BulkUpdateTrashErrors, ThrowOnError>({
        responseType: 'json',
        url: '/v1/items/bulk/trash',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * Deletes items (and related resources) in bulk
 */
export const deleteItems = <ThrowOnError extends boolean = false>(options: Options<DeleteItemsData, ThrowOnError>) => {
    return (options.client ?? client).delete<DeleteItemsResponses, DeleteItemsErrors, ThrowOnError>({
        responseType: 'json',
        url: '/v1/items',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * Returns a list of tags statistics for items
 */
export const fetchItemsTagsStats = <ThrowOnError extends boolean = false>(options: Options<FetchItemsTagsStatsData, ThrowOnError>) => {
    return (options.client ?? client).post<FetchItemsTagsStatsResponses, FetchItemsTagsStatsErrors, ThrowOnError>({
        responseType: 'json',
        url: '/v1/items/tags/stats',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * Returns the top 5 relevant items
 */
export const searchItemsAutocomplete = <ThrowOnError extends boolean = false>(options?: Options<SearchItemsAutocompleteData, ThrowOnError>) => {
    return (options?.client ?? client).get<SearchItemsAutocompleteResponses, SearchItemsAutocompleteErrors, ThrowOnError>({
        responseType: 'json',
        url: '/v1/items/autocomplete',
        ...options
    });
};

/**
 * Returns paginated search results for items
 */
export const searchItems = <ThrowOnError extends boolean = false>(options?: Options<SearchItemsData, ThrowOnError>) => {
    return (options?.client ?? client).get<SearchItemsResponses, SearchItemsErrors, ThrowOnError>({
        responseType: 'json',
        url: '/v1/items/search',
        ...options
    });
};

/**
 * Deletes tag
 */
export const deleteTag = <ThrowOnError extends boolean = false>(options: Options<DeleteTagData, ThrowOnError>) => {
    return (options.client ?? client).delete<DeleteTagResponses, DeleteTagErrors, ThrowOnError>({
        responseType: 'json',
        url: '/v1/tag/{id}',
        ...options
    });
};

/**
 * Updates a tag and returns it
 */
export const updateTag = <ThrowOnError extends boolean = false>(options: Options<UpdateTagData, ThrowOnError>) => {
    return (options.client ?? client).patch<UpdateTagResponses, UpdateTagErrors, ThrowOnError>({
        responseType: 'json',
        url: '/v1/tag/{id}',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * Returns all tags
 */
export const getTags = <ThrowOnError extends boolean = false>(options?: Options<GetTagsData, ThrowOnError>) => {
    return (options?.client ?? client).get<GetTagsResponses, GetTagsErrors, ThrowOnError>({
        responseType: 'json',
        url: '/v1/tags',
        ...options
    });
};

/**
 * Creates a tag and returns it
 */
export const createTag = <ThrowOnError extends boolean = false>(options: Options<CreateTagData, ThrowOnError>) => {
    return (options.client ?? client).post<CreateTagResponses, CreateTagErrors, ThrowOnError>({
        responseType: 'json',
        url: '/v1/tag',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};
